import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API } from "../lib/api";

const SettingsContext = createContext({
  supplier_name: "Ultra",
  welove_logo_url: null,
  giavani_logo_url: null,
  overdue_days: 7,
  overdue_mode: "days_with_third_party",
  show_demo_logins: true,
  reload: () => {},
});

export function SettingsProvider({ children }) {
  const [s, setS] = useState({ supplier_name: "Ultra", welove_logo_url: null, giavani_logo_url: null, overdue_days: 7, overdue_mode: "days_with_third_party", show_demo_logins: true });

  const reload = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setS({
        supplier_name: r.data.supplier_name || "Ultra",
        welove_logo_url: r.data.welove_logo_url ? `${API.replace(/\/api$/, "")}${r.data.welove_logo_url}` : null,
        giavani_logo_url: r.data.giavani_logo_url ? `${API.replace(/\/api$/, "")}${r.data.giavani_logo_url}` : null,
        overdue_days: r.data.overdue_days || 7,
        overdue_mode: r.data.overdue_mode || "days_with_third_party",
        show_demo_logins: r.data.show_demo_logins !== false,
      });
    } catch {
      /* not authenticated — keep defaults */
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("wbt_token");
    if (token) reload();
  }, [reload]);

  return (
    <SettingsContext.Provider value={{ ...s, reload }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
